export enum NameAttributes {
	COLOR = 'color',
	SIZE = 'size',
	FLAVOR = 'flavor',
	MODALITY = 'modality',
	OBJECTIVE = 'objective',
}
